import { render, staticRenderFns } from "./WidgetTop5.vue?vue&type=template&id=19fa937c&scoped=true&"
import script from "./WidgetTop5.vue?vue&type=script&lang=js&"
export * from "./WidgetTop5.vue?vue&type=script&lang=js&"
import style0 from "./WidgetTop5.vue?vue&type=style&index=0&id=19fa937c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fa937c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\laragon\\www\\elipse-citas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19fa937c')) {
      api.createRecord('19fa937c', component.options)
    } else {
      api.reload('19fa937c', component.options)
    }
    module.hot.accept("./WidgetTop5.vue?vue&type=template&id=19fa937c&scoped=true&", function () {
      api.rerender('19fa937c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Home/WidgetTop5.vue"
export default component.exports